import { render } from "./form-question.vue?vue&type=template&id=979a691c&ts=true"
import script from "./form-question.vue?vue&type=script&lang=ts"
export * from "./form-question.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__